import * as React from 'react';

import Button from '@mui/material/Button';
import { useEffect } from 'react';
import UserAuthService from '../services/UserAuthService';
import { useNavigate, useSearchParams } from 'react-router';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import Alert from '@mui/material/Alert';
import { Box, CircularProgress, FormHelperText, Grid, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { IXSifterDiscoverTextSite } from '../types/XSifterAppUser';
import { setDisplayMessage, setDisplayMessageType } from '../store/XSifterAppReducer';

const DiscoverTextLoginImage = require('./common/login_with_discovertext.png');

interface IXSifterLoginProps {

}

const XSifterLogin: React.FC<IXSifterLoginProps> = (props: IXSifterLoginProps) => {
    const displayMessage = useAppSelector((state) => state.app.displayMessage);
    const displayMessageType = useAppSelector((state) => state.app.displayMessageTyoe);
    const currentUser = useAppSelector((state) => state.app.currentUser); 
    const [isLoadingLogin, setIsLoadingLogin] = React.useState<boolean>(true);
    const [chosenDtSite, setChosenDtSite] = React.useState<string>("");
    const [dtAvailableSites, setDtAvailableSites] = React.useState<IXSifterDiscoverTextSite[]>([]);
    const userAuthService = UserAuthService.getInstance();
    const navigate = useNavigate();

    useEffect(() => {
        userAuthService.setCurrentUser(currentUser);
        if (userAuthService.isLoggedIn()) {
            navigate('/app');
            return;
        }

        userAuthService.getDiscoverTextSites()
            .then((sites) => {
                if (sites.sites.length > 0) {
                    setChosenDtSite(sites.sites[0].hostname);
                }
                setDtAvailableSites(sites.sites);
            }).catch(() => {
            }).finally(() => {
                setIsLoadingLogin(false);
            })

    }, []);
        
    const onDiscoverTextLoginClick = (e) => {
        setIsLoadingLogin(true);
        setIsLoadingLogin(true);
        userAuthService.getOAuthUrl(chosenDtSite)
            .then((loginUrl) => {
                window.location.href = loginUrl;
            }).catch((error: any) => {
                dispatch(setDisplayMessage("Could not get the login information from DiscoverText. Try again in a few minutes."));
                dispatch(setDisplayMessageType("warning"));
            });
    }

    const onChooseDiscoverTextSite = (event: SelectChangeEvent<string>) => {
        setChosenDtSite(event.target.value);
    }

    const alertType = displayMessageType || "success";

    return (
        <>
            <h1>XSifter Login</h1>
            {displayMessage && <Alert severity={alertType}>{displayMessage}</Alert>}
            <p>Login with your DiscoverText account below</p>
            { isLoadingLogin ? <CircularProgress aria-label="Loading…" /> :
            <Box>
                {dtAvailableSites.length > 1 &&
                <>
                    <FormHelperText id="choose-dt-site">
                            DiscoverText Site
                    </FormHelperText>
                    <Select id="id-choose-dt-site"
                        defaultValue={""}
                        value={chosenDtSite}
                        onChange={onChooseDiscoverTextSite}
                        label-id="choose-dt-site"
                        style={{ marginRight: "16px", marginTop: "2px", borderRadius: "8px", minHeight: "60px"}}
                        disabled={isLoadingLogin}
                    >
                        {dtAvailableSites.map((site) =>
                            <MenuItem key={site.hostname} value={site.hostname}>{site.displayName}</MenuItem>
                        )}
                    </Select>
                </>
                }
                <Button variant='outlined' onClick={onDiscoverTextLoginClick} disabled={isLoadingLogin} style={{ borderRadius: "8px", minHeight: "60px"}}>
                    <img src={DiscoverTextLoginImage} alt="login with DiscoverText" />
                </Button>
            </Box>
            }
            <p>You must have a valid <a href="https://discovertext.com" target='_blank'>DiscoverText</a> <strong>enterprise account</strong> to log in.</p>
        </>
    );
}

export default XSifterLogin;

function dispatch(arg0: any) {
    throw new Error('Function not implemented.');
}
